import React from 'react'
import * as d3 from 'd3'
import $ from 'jquery'
import 'materialize-css'
import { mobileCheck } from '../helpers/utils'


class BarChart extends React.Component{
  constructor(props){
    super(props)
    this.initBarchart = this.initBarchart.bind(this)
    this.getChartComponents = this.getChartComponents.bind(this)
    this.resizeHandler = this.resizeHandler.bind(this)
  }

  shouldComponentUpdate(){
    return false
  }

  componentDidMount(){
    this.initBarchart()
  }

  componentWillMount(){
    window.addEventListener('resize', this.resizeHandler)
    document.addEventListener('orientationchange', this.resizeHandler)
  }

  componentWillunmount(){
    window.removeEventListener('resize', this.resizeHandler)
    document.removeEventListener('orientationchange', this.resizeHandler)
  }

  getChartComponents(){
    let mobile = mobileCheck()
    let width
    let divWidth = document.getElementById("barchart").clientWidth

    let margin = {left:110, right:110, top:50, bottom:50}
    
    if (mobile || window.innerWidth<750){
      width = divWidth-220
      
    }
    else {
      width = 500 
      margin.right = margin.left = (divWidth-width)/2. 
    }

    let x = d3.scaleLinear().domain([0, d3.max(this.props.chartData, (d)=>{return d.years})]).rangeRound([0, width])

    return{
      margin:margin, 
      width: width, 
      height: 250, 
      x: x,
      xAxis: d3.axisBottom(x).tickFormat(d3.format('d')).ticks(x.domain()[1])
    }

  }

  initBarchart(){
    const chartComponents = this.getChartComponents()
    const margin = chartComponents.margin
    const width = chartComponents.width
    const height = chartComponents.height
    const x = chartComponents.x
    const xAxis = chartComponents.xAxis
  

    let y = d3.scaleBand().rangeRound([0,height]).padding(0.1)
    let yAxis = d3.axisLeft(y)

    // Set domains and ticks
    y.domain(this.props.chartData.map((d)=>{return d.lang}))
    


    // Add SVG
    let svg = d3.selectAll('#barchart')
                .append('svg')
                .attr('height', margin.top+margin.bottom+height)
                .attr('width', margin.left+margin.right+width)
                .append('g')
                .attr('transform', `translate(${margin.left},${margin.top})`)


    // Add axes and labels
    svg.append('g')
      .attr('class', 'x axis')
      .attr('transform', `translate(0, ${height})`)
      .call(xAxis)
      .append('text')
      .attr('class', 'barchart-x-axis-label')
      .text('Years')
      .attr('x', x(2.5))
      .attr('dy', '3em')
      .style('fill','#000')
      .style('font-size', '1.3em')

    svg.append('g')
       .attr('class', 'y axis')
       .call(yAxis)
       .selectAll('.tick text')
       .style('font-size','1.3em')



    // draw chart with scrollFIRE
    let options = [{selector: '#barchart', offset: 250, callback: ()=>{draw(this.props.chartData)} }]
    Materialize.scrollFire(options);


    // Add bars function to be called with scrollFire
    function draw(data){
      svg.selectAll('.bar')
         .data(data)
         .enter()
         .append('rect')
         .attr('class', 'bar')
         .attr('y', function(d){ return y(d.lang) })
         .attr('x', function(d){ return x(0) })
         .attr('height', y.bandwidth())
         .attr('width', 0)
         .style('fill', '#9D95D0')
         .transition()
         .duration(1000)
         .ease(d3.easeBounceOut)
         .delay((d, i)=>{return (Math.floor(Math.random()*80)+40 )*i}) //Rand between 40 and 80
         .attr('width', (d)=>{return x(d.years)})
    }
  }


  resizeHandler(){
    const chartComponents = this.getChartComponents()
    const margin = chartComponents.margin
    const width = chartComponents.width
    const height = chartComponents.height
    const x = chartComponents.x
    const xAxis = chartComponents.xAxis
    
    const svg = d3.select('#barchart')
                  .select('svg')
                  .attr('height',margin.top+margin.bottom+height)
                  .attr('width',margin.left+margin.right+width)
                  .select('g')
                  .attr('transform', `translate(${margin.left},${margin.top})`);

    // Reize SVG
    svg.attr('height', margin.top+margin.bottom+height)
       .attr('width', margin.left+margin.right+width)
       .select('g')
       .attr('transform', `translate(${margin.left},${margin.top})`)


    // Rescale X axis
    // x.rangeRound([0, width])

    svg.select('.x.axis')
       .attr('transform', `translate(0, ${height})`)
       .call(xAxis)
       .select('.barchart-x-axis-label')
       .attr('x', x(2.5))

    // Rescale bars
    svg.selectAll('.bar')
       .attr('x', function(d){ return x(0) })
       .attr('width', (d)=>{return x(d.years)})
  }


  

  render(){
    return <div id="barchart"></div>
  }
}

export default BarChart


// WEBPACK FOOTER //
// ./app/components/BarChart.js